import http from '../../../Utils/http';
const ChangeUserPassword = {
  name: 'changePassword',
  state: {
    loading: false,
    error: '',
    isPasswordChanged: false,
    permissions: [
      'organization:view',
      'organization:create',
      'organization:delete',
      'organization:update',
    ],
  },
  reducers: {
    changePasswordRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        isPasswordChanged: false,
        message: ''
      };
    },
    changePasswordReceived(state, payload) {
      return {
        ...state,
        loading: false,
        isPasswordChanged: true,
        message: payload,
        error: '',
      }
    },
    clearStates(state) {
      return {
        ...state,
        loading: false,
        error: '',
        isPasswordChanged: false,
        message: ''
      };
    },
    changePasswordRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
        message: '',
        isPasswordChanged: false,
        loading: false,
      };
    },

  },
  effects: (dispatch) => ({
    async requestForChangePassword(data) {
      try {
        this.changePasswordRequested();
        const response = await http.put(`/auth/change-password`, data);
        this.changePasswordReceived(response.data.message);
      } catch (err) {
        this.changePasswordRequestFailed(err.response.data.error)
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
      }
    },
    async changePassword(data) {
      try {
        this.changePasswordRequested();
        const id = JSON.parse(localStorage.getItem('userInfo'))?.id;
        const newData = {
          old_password: data?.old_password,
          new_password: data?.new_password,
        }
        const response = await http.put(`/savvy/users/changePassword/${id}`, newData);
        this.changePasswordReceived(response.data.message);
      } catch (err) {
        this.changePasswordRequestFailed(err.response.data.error)
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
      }
    },
    async clearData() {
      // this.changePasswordReceived('');
      this.clearStates();
    }
  }),
};

export default ChangeUserPassword;